import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import styled from "styled-components";

const ChartContainer = styled.div`
  /* width: 100%; */
  height: 340px;
  margin: 0px;
  /* max-width: 600px; */
  flex: 1;
`;
interface MonthlyData {
 date:string,
 status:string,
 count?:number,
 users:number,
 properties:number,
 day:number
}

const Charts = ({ data,type }: { data: MonthlyData[],type:'user'|'property' }) => {
 
  function getHighestCountRounded(data: MonthlyData[]) {
    // Extract the 'count' values from each object
    const allCounts = data.map(obj => type==='user'?obj.users:obj.properties);

    // Find the highest count
    const highestCount = Math.max(...allCounts);

    // Round it off to the nearest multiple of 10
    const roundedCount = Math.round(highestCount / 10) * 10;

    return roundedCount;
}


  return (
    <ChartContainer>
      <ResponsiveContainer width={"100%"} height={"100%"}>
        <LineChart
          width={400}
          height={400}
          data={data.length>0?data:[{}]}
          
          margin={{
            top: 30,
            right: 0,
            left: 0,
          }}
          
        >
          {/* <Line
            type="bumpY"
            dataKey="NoOfUsers"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          /> */}
          <Line type="bump" dataKey={type==='user'?"users":'properties'}  stroke={type==='user'? "#82ca9d":'#0000FF'} />
          <XAxis dataKey="date"  />
          <YAxis domain={[1, data.length>0?getHighestCountRounded(data):10]} allowDataOverflow />
          <Tooltip />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default Charts;
